import {
  IMasterData,
  IMasterDataCreate,
  IMasterDataTable,
  IPagedData,
  IPagedSearch,
  ISelectItem,
  TableStatus,
} from '@evencel/models';

export class GetMasterData {
  public static readonly type = '[MasterData] GetMasterData';
  constructor(public id: string) {}
}

export class ActivateMasterData {
  public static readonly type = '[MasterData] ActivateMasterData';
  constructor(public masterData: IMasterDataTable) {}
}

export class SearchMasterDatas {
  public static readonly type = '[MasterData] SearchMasterDatas';
  constructor(public data: IPagedSearch) {}
}

export class CreateMasterData {
  public static readonly type = '[MasterData] SaveMasterData';
  constructor(public masterData: IMasterDataCreate) {}
}

export class UpdateMasterData {
  public static readonly type = '[MasterData] UpdateMasterData';
  constructor(public masterData: IMasterData) {}
}

export class DeleteMasterData {
  public static readonly type = '[MasterData] DeleteMasterData';
  constructor(public masterData: IMasterDataTable) {}
}

export class RestoreMasterData {
  public static readonly type = '[MasterData] RestoreMasterData';
  constructor(public masterData: IMasterDataTable) {}
}

export class GetMasterDatasResponse {
  public static readonly type = '[MasterData] GetMasterDatasResponse';
  constructor(
    public pagedData: IPagedData<IMasterData>,
    public status: TableStatus
  ) {}
}

export class GetMasterDataResponse {
  public static readonly type = '[MasterData] GetMasterDataResponse';
  constructor(public masterData: IMasterData) {}
}

export class CreateMasterDataValue {
  public static readonly type = '[MasterData] CreateMasterDataValue';
  constructor(public masterDataId: string, public value: ISelectItem) {}
}

export class UpdateMasterDataValue {
  public static readonly type = '[MasterData] UpdateMasterDataValue';
  constructor(public masterDataId: string, public value: ISelectItem) {}
}

export class DeleteMasterDataValue {
  public static readonly type = '[MasterData] DeleteMasterDataValue';
  constructor(public masterDataId: string, public value: ISelectItem) {}
}

export class ActivateMasterDataValue {
  public static readonly type = '[MasterData] ActivateMasterDataValue';
  constructor(public masterDataId: string, public value: ISelectItem) {}
}
